import S3 from 'aws-sdk/clients/s3';
import AWS from 'aws-sdk';

import config from 'config';
import client from 'helpers/client';
import cognito from 'helpers/cognito';

export const putObject = (params, callback) => {
  return async (dispatch, getState) => {
    const { file, path, signals, prefix } = params;

    dispatch({ type: signals.onStart });

    // In development, use API endpoint instead of direct S3 upload
    if (config.env === 'development') {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', path.split('/')[0] || 'product');

        const authHeaders = await cognito.getHeaderAuthorization();
        const headers = {
          headers: authHeaders,
        };
        const response = await client.api('/image/upload', 'post', formData, headers);

        dispatch({ type: signals.onSuccess });

        const fileUrl = response.data.data.imageLink;

        callback && callback(fileUrl);
      } catch (err) {
        dispatch({
          type: signals.onFailure,
          payload: String(err),
        });
      }
      return;
    }

    // Production: use direct S3 upload
    const { AccessKeyId, SecretKey, SessionToken } = getState().user.credentials;

    const s3 = new S3({
        apiVersion: '2006-03-01',
        params: { Bucket: config.s3.BUCKET },
        signatureVersion: 'v4',
        region: config.s3.REGION,
        credentials: new AWS.Credentials(AccessKeyId, SecretKey, SessionToken),
      }),
      key = `${path}${prefix}${Date.now()}.${file.type.split('/')[1]}`;

    s3.putObject(
      {
        Bucket: config.s3.BUCKET,
        Key: key,
        Body: file,
        ACL: 'public-read',
        ContentType: file.type,
      },
      (err, data) => {
        if (err)
          return dispatch({
            type: signals.onFailure,
            payload: String(err),
          });

        dispatch({ type: signals.onSuccess });

        const fileUrl = `${config.s3.URL}${config.s3.BUCKET}/${key}`;

        callback && callback(fileUrl);
      },
    );
  };
};
